export default __webpack_public_path__ + "static/media/campaign_mockup.4c01adce.png";